import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const userReducer = createSlice({
  name: "userReducer",
  initialState: initialState,
  reducers: {
    setUser: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateUser: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
    resetUser: () => {
      return initialState;
    },
  },
});

export const { setUser, updateUser, resetUser } = userReducer.actions;

export default userReducer.reducer;
